import { render, staticRenderFns } from "./AutomaticPublications.vue?vue&type=template&id=14d5b77b&scoped=true&transition=scale-transition&origin=center%20center&"
import script from "./AutomaticPublications.vue?vue&type=script&lang=js&"
export * from "./AutomaticPublications.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticPublications.vue?vue&type=style&index=0&id=14d5b77b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d5b77b",
  null
  
)

export default component.exports